module.exports = __webpack_public_path__ + "img/join_4_3.73e8652e.jpg";